// Hex boundary tracing: emits cell-edge segments with the interior on the
// left, chains them into loops (contours.ts), ready for relax + Chaikin.

import { chainLoops, loopArea, relaxLoop, restoreArea, smoothLoop, type Loop, type Segment } from './contours';
import { COLS, ROWS, cellCenter, hexCorner, neighborAt } from '../world';

// `cols` and `rows` default to the live grid the server sent (R261). A
// caller that traces another grid passes its own.
export function traceHexLoops(mask: Uint8Array, id: number, cols = COLS, rows = ROWS): Loop[] {
  const segs: Segment[] = [];
  const cells = Math.min(mask.length, cols * rows);
  for (let i = 0; i < cells; i++) {
    if (mask[i] !== id) continue;
    const [cx, cy] = cellCenter(i, cols);
    for (let k = 0; k < 6; k++) {
      const n = neighborAt(i, k, cols, rows);
      if (n >= 0 && mask[n] === id) continue;
      const a = hexCorner(k), b = hexCorner((k + 1) % 6);
      segs.push([cx + a[0], cy + a[1], cx + b[0], cy + b[1]]);
    }
  }
  return chainLoops(segs);
}

// Full pipeline: trace -> Laplacian relax -> put the area relaxation took
// back -> Chaikin. Defaults per docs/design/ui-map-interface.md §4.2
// (territory: relax 6, chaikin 3).
export function outlineLoops(
  mask: Uint8Array, id: number, relax = 6, chaikin = 3, cols = COLS, rows = ROWS,
): Loop[] {
  return traceHexLoops(mask, id, cols, rows).map((l) =>
    smoothLoop(restoreArea(relaxLoop(l, relax), Math.abs(loopArea(l))), chaikin),
  );
}
